import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function TelegramShareIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M2.10203 10.4851C2.10203 10.4851 11.8565 6.33385 15.2398 4.8721C16.5365 4.2871 20.9345 2.41735 20.9345 2.41735C20.9345 2.41735 22.964 1.59835 22.7945 3.5866C22.739 4.4041 22.2875 7.2691 21.8368 10.3681C21.1603 14.7526 20.4268 19.5466 20.4268 19.5466C20.4268 19.5466 20.3143 20.8914 19.3558 21.1246C18.3973 21.3586 16.8185 20.3064 16.5358 20.0724C16.2545 19.8384 12.3073 17.2666 10.8418 15.9804C10.4465 15.6294 9.99578 14.9281 10.898 14.1091C12.9275 12.1801 15.353 9.7831 16.8185 8.26285C17.495 7.5616 18.1715 5.9251 15.3523 7.9126C11.3488 10.7776 7.40228 13.4664 7.40228 13.4664C7.40228 13.4664 6.50003 14.0514 4.80803 13.5249C3.11678 12.9984 1.14353 12.2971 1.14353 12.2971C1.14353 12.2971 -0.209469 11.4196 2.10203 10.4851Z"
        fill="inherit"
      />
    </SvgIcon>
  );
}
